import { render, staticRenderFns } from "./inputNumberRange.vue?vue&type=template&id=636b7702"
import script from "./inputNumberRange.vue?vue&type=script&lang=js"
export * from "./inputNumberRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports